import type { FundAccountPostingsPage } from '../../types/fundAccountPostings.types';
import { lineTotalLabel } from '../../utils/fundStatementLabels';
import type { PostingsLayout } from '../../utils/postingsLayout';
import { FigureCell } from '../DealerFinancials/FundStatementPeriod/PeriodStatementBody/FigureCell';
import {
    LABEL_SPAN_TO_GROSS,
    LABEL_SPAN_TO_NET,
    STATEMENT_GRID,
} from '../DealerFinancials/FundStatementPeriod/PeriodStatementBody/statementGrid';

interface Props {
    label: string;
    layout: PostingsLayout;
    page: FundAccountPostingsPage;
    currency: string;
}

export function PostingsTotals({ label, layout, page, currency }: Props) {
    const split = layout === 'split';
    return (
        <dl className={`${STATEMENT_GRID} text-sm font-semibold`}>
            <dt className={split ? LABEL_SPAN_TO_GROSS : LABEL_SPAN_TO_NET}>{lineTotalLabel(label)}</dt>
            {split && (
                <>
                    <FigureCell column="Gross" value={page.amount} currency={currency} />
                    <FigureCell column="VAT" value={page.vat} currency={currency} />
                </>
            )}
            <FigureCell column="Net" value={page.net} currency={currency} />
        </dl>
    );
}
